export const dispatchExpectionToast = (dispatch, i18n)  => {
  dispatch("toaster/push", {
    id: `email-prefrences-${Date.now()}`,
    message: i18n.t("error-500"),
    type: "error"
  }, {
    root: true
  });
};
